import Vue from 'vue'
import App from './App.vue'
import Router from 'vue-router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import { IsPC } from './assets/js/utils'

Vue.use(VueAwesomeSwiper, {
  autoplay: {
    disableOnInteraction: false
  },
  pagination: {
    el: '.swiper-pagination',
    clickable :true,
  }
})
Vue.use(Router)
Vue.config.productionTip = false


const pc_router = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    component: () => import('./view/PC_Home.vue')
  }
]

const mobile_router = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    component: () => import('./view/Mobile_Home.vue')
  }
]

const routes = IsPC() ?  pc_router : mobile_router

new Vue({
  render: h => h(App),
  router: new Router({routes}),
}).$mount('#app')
